module.exports = __webpack_public_path__ + "img/block8.b2253fa9.png";